export default [
  {
    path: '/batteryAssistant/:deviceId/:vin/:userId',
    component: () => import('@/views/batteryAssistant/Index.vue'),
    name: 'batteryAssistant',
    meta: {
      title: '电池助手',
      backgroundClass: 'bg-gray',
    },
  },
  {
    path: '/purChase/:pageType',
    redirect: (to) => {
      return { name: 'batteryAssistant.purChase', params: to.params, query: to.query };
    },
    name: 'purChase',
  },
  {
    path: '/batteryAssistant/purChase/:pageType',
    component: () => import('@/views/batteryAssistant/PurChase.vue'),
    name: 'batteryAssistant.purChase',
    meta: {
      title: '电池助手',
      backgroundClass: 'bg-gray',
    },
  },
  {
    path: '/batteryAssistant/list',
    component: () => import('@/views/batteryAssistant/List.vue'),
    name: 'batteryAssistant.list',
    meta: {
      title: '购买记录',
      backgroundClass: 'bg-gray',
    },
  },
  {
    path: '/batteryAssistant/payChose',
    component: () => import('@/views/batteryAssistant/PayChose.vue'),
    name: 'batteryAssistant.payChose',
    meta: {
      title: '立即购买',
      backgroundClass: 'bg-gray',
    },
  },
  {
    path: '/drivingMode/edit/:deviceId/:type/:id',
    component: () => import('@/views/drivingMode/Edit.vue'),
    name: 'drivingMode.edit',
    meta: {
      title: '大师模式',
      backgroundClass: 'bg-gray',
    },
  },
  {
    path: '/drivingMode/add/:deviceId/:type',
    component: () => import('@/views/drivingMode/Edit.vue'),
    name: 'drivingMode.add',
    meta: {
      title: '大师模式',
      backgroundClass: 'bg-gray',
    },
  },
  {
    path: '/drivingMode/:deviceId/:userId/:vin',
    component: () => import('@/views/drivingMode/Index.vue'),
    name: 'drivingMode',
    meta: {
      title: '大师模式',
      backgroundClass: 'bg-gray',
    },
  },
];
